import * as Yup from 'yup';

export const formSchema = [
  {
    name: 'refferalCode',
    validate: Yup.string().test(
      'len',
      'Mã giới thiệu phải đủ 8 kí tự',
      (val) => val?.toString().length === 8,
    ),
  },
];
